/**
 * Shared constants for case/workspace logic.
 * Imported by CaseStatusSidebar, CaseWorkspacePage, and GuidancePromptCard.
 */

/** Maps EvaluationIssue.section values → wizard step URL segments. */
export const SECTION_TO_STEP: Record<string, string> = {
  personal: "personal",
  biographic: "biographic",
  addresses: "addresses",
  employment: "employment",
  travel: "travel",
  marriage: "marriage",
  children: "children",
  criminal: "criminal",
  documents: "documents",
  oath: "oath",
  contact: "contact",
  "fee-reduction": "fee-reduction",
  fee_reduction: "fee-reduction",
  interpreter: "interpreter",
  preparer: "preparer",
  checkout: "checkout",
  review: "review",
};
